import { Layout as AntLayout } from 'antd';
import styled from 'styled-components';

export const Layout = styled(AntLayout)`
  align-items: stretch;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const Sider = styled(Layout.Sider)`
  flex: 0 0 256px;
  max-width: 256px;
  min-width: 256px;
  width: 256px;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  background: var(--white-100);
`;

export const Content = styled(Layout.Content)`
  border-left: 1px solid var(--border-color);
  align-items: stretch;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const Wrapper = styled.div`
  position: relative;
  padding-left: var(--left-spacing);
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: stretch;
`;

export const Overlay = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--zindex-layer-03) !important;
  justify-content: center;
`;

export const LoadingOverlay = styled(Overlay)`
  flex-direction: column;
  padding-top: var(--layout-02);
  padding-left: var(--layout-02);
  flex: 1 1 100%;
`;

export const Flex = styled.div`
  width: 100%;
  height: 100%;
  /** TODO: Fix ant input number, remove quick fix */
  .ant-input-number {
    border: 1px solid transparent !important;
    box-shadow: none;

    input {
      text-align: right;
      padding-right: var(--layout-02);
    }
  }

  &.multi-select .ag-selection-checkbox {
    opacity: 1;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: var(--spacing-03);
`;
